export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/google_pay.5543313f.svg","height":11,"width":20,"blurWidth":0,"blurHeight":0};